import React, { FC, ReactNode } from 'react'
import Tooltip from 'rc-tooltip'
import styled from 'styled-components'
import cx from 'classnames'

interface Props {
  description?: ReactNode
  id?: string
  forceMode?: 'tooltip' | 'inline'
  className?: string
}

// Warning: This component is kinda fucked up. It heavily relies on opaque class-based css magic
// If you find yourself having to make significant changes to this component, please consider refactoring
// the whole description concept into something more sane.
export const Description: React.FC<Props> = ({ description, id, forceMode, className }) => {
  if (!description) {
    return <div className={cx('reactjsonform-description', className)} />
  }

  if (forceMode === 'inline') {
    return (
      <div className={cx('reactjsonform-description', className)} id={id}>
        <p>{description}</p>
      </div>
    )
  }

  if (forceMode === 'tooltip') {
    return (
      <DivWithZIndex className={cx('reactjsonform-description', className)} id={id}>
        <Tooltip
          placement="top"
          overlayStyle={{ maxWidth: 250 }}
          overlay={<span>{description}</span>}
        >
          <div className="reactjsonform-description-icon">
            <i className="fas fa-question-circle" />
          </div>
        </Tooltip>
      </DivWithZIndex>
    )
  }

  return (
    <DivWithZIndex className={cx('reactjsonform-description', 'non-forced', className)} id={id}>
      <Tooltip
        placement="top"
        overlayStyle={{ maxWidth: 250 }}
        overlay={<span>{description}</span>}
      >
        <div className="reactjsonform-description-icon">
          <i className="fas fa-question-circle" />
        </div>
      </Tooltip>

      <p className="reactjsonform-description-text">{description}</p>
    </DivWithZIndex>
  )
}

// This is useful when we need to inline Description inside schema
export const SchemaInlinedDescription: FC<Omit<Props, 'forceMode'>> = ({ ...props }) => {
  return <StyledDescription forceMode="tooltip" {...props} />
}

const StyledDescription = styled(Description)`
  display: inline-block;
  margin-left: 5px;
`

const DivWithZIndex = styled.div`
  // Any number will work - we just need to display this over its later siblings.
  z-index: 1;
`
